var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge-status",class:_vm.isActive ? 'badge-status--active' : 'badge-status--inactive'},[_c('span',{staticClass:"badge-dot"}),_vm._v(" "+_vm._s(_vm.isActive ? 'Active' : 'Inactive')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }